// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */
@layer properties;
.multi-selection-inner {
  max-width: 50ch;
  min-width: 100%;
  display: flex;
  height: auto;
  max-height: min(500px, 70dvh);
  flex-direction: column;
  .search {
    margin-bottom: calc(var(--spacing, 0.25rem) * 2);
    padding-inline: calc(var(--spacing, 0.25rem) * 2);
  }
  .item {
    display: flex;
    align-items: center;
    column-gap: calc(var(--spacing, 0.25rem) * 2);
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
    border-bottom-color: var(--color-gray-200, oklch(92.8% 0.006 264.531));
    padding-inline: calc(var(--spacing, 0.25rem) * 3);
    padding-block: calc(var(--spacing, 0.25rem) * 2);
    --tw-font-weight: var(--font-weight-semibold, 600);
    font-weight: var(--font-weight-semibold, 600);
    font-size: 12px;
    [type=checkbox] {
      margin: calc(var(--spacing, 0.25rem) * 0);
    }
    &:hover:not(.group) {
      cursor: pointer;
      background-color: var(--color-gray-200, oklch(92.8% 0.006 264.531));
    }
    &.disabled {
      cursor: not-allowed;
      color: var(--color-gray-400, oklch(70.7% 0.022 261.325));
    }
  }
  .items {
    position: relative;
    display: block;
    &::before {
      position: absolute;
      border-left-style: var(--tw-border-style);
      border-left-width: 1px;
      --tw-border-style: dotted;
      border-style: dotted;
      border-bottom-color: var(--color-gray-400, oklch(70.7% 0.022 261.325));
      top: calc(var(--spacing, 0.25rem) * 5.5);
      bottom: calc(var(--spacing, 0.25rem) * 0);
      left: calc(var(--spacing, 0.25rem) * 2.5);
      content: "";
    }
    multi-selection-item {
      position: relative;
      display: block;
      padding-left: calc(var(--spacing, 0.25rem) * 2.5);
      &::before {
        position: absolute;
        border-top-style: var(--tw-border-style);
        border-top-width: 1px;
        --tw-border-style: dotted;
        border-style: dotted;
        border-bottom-color: var(--color-gray-400, oklch(70.7% 0.022 261.325));
        top: calc(var(--spacing, 0.25rem) * 5.5);
        left: calc(var(--spacing, 0.25rem) * 3);
        width: calc(var(--spacing, 0.25rem) * 3);
        content: "";
      }
    }
  }
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-font-weight: initial;
    }
  }
}

`, "",{"version":3,"sources":["<no source>","webpack://./app/Components/Forms/MultiSelection/multi-selection-inner/multi-selection-inner.component.css"],"names":[],"mappings":"AAAA,iEAAA;ACWiE,iBAAQ;AATzE;EACsB,eAAY;EAAvB,eAAU;EACV,aAAI;EAAU,YAAM;EAAC,6BAAwB;EAAxC,sBAAQ;EAEpB;IACW,gDAAI;IAAC,iDAAI;EACnB;EAED;IACmC,aAAI;IAAC,mBAAY;IAAC,6CAAO;IAAC,2CAAQ;IAAR,wBAAQ;IAAC,sEAAiB;IAA5E,iDAAI;IAAC,gDAAI;IAAC,kDAAa;IAAb,6CAAa;IAC9B,eAAgB;IAEhB;MACW,yCAAG;IACb;IAED;MACW,eAAc;MAAC,mEAAW;IACpC;IAED;MACyB,mBAAkB;MAAhC,wDAAa;IACvB;EACJ;EAED;IACW,kBAAQ;IAAC,cAAK;IAErB;MACW,kBAAQ;MAAC,yCAAQ;MAAR,sBAAQ;MAAC,yBAAa;MAAb,oBAAa;MAAC,sEAAiB;MAC/B,wCAAO;MAAzB,yCAAQ;MAAC,yCAAQ;MACxB,WAAY;IACf;IAED;MACwB,kBAAQ;MAAd,cAAK;MAAZ,iDAAM;MAEb;QACW,kBAAQ;QAAC,wCAAQ;QAAR,qBAAQ;QAAC,yBAAa;QAAb,oBAAa;QAAC,sEAAiB;QAC1C,wCAAO;QAAd,uCAAM;QAAS,wCAAG;QACzB,WAAY;MACf;IACJ;EACJ;AACJ;AAnCgE;EAAA,WAAQ;EAAR,eAAQ;EAAR,oBAAQ;AAAA;AAAhD;EAAA,WAAa;EAAb,eAAa;AAAA;AAA2B;EAAA;IAAA;MAAA,wBAAQ;MAAhD,yBAAa;IAAmC;EAAA;AAAA","sourcesContent":[null,"@reference \"../../../../assets/css/main.css\";\r\n\r\n.multi-selection-inner {\r\n    @apply min-w-full max-w-[50ch];\r\n    @apply flex flex-col h-auto max-h-[min(500px,70dvh)];\r\n\r\n    .search {\r\n        @apply mb-2 px-2;\r\n    }\r\n\r\n    .item {\r\n        @apply px-3 py-2 font-semibold flex items-center gap-x-2 border-b border-b-gray-200;\r\n        font-size: 12px;\r\n\r\n        [type=checkbox] {\r\n            @apply m-0;\r\n        }\r\n\r\n        &:hover:not(.group) {\r\n            @apply cursor-pointer bg-gray-200;\r\n        }\r\n\r\n        &.disabled {\r\n            @apply text-gray-400 cursor-not-allowed;\r\n        }\r\n    }\r\n\r\n    .items {\r\n        @apply relative block;\r\n\r\n        &::before {\r\n            @apply absolute border-l border-dotted border-b-gray-400;\r\n            @apply bottom-0 left-2.5 top-5.5;\r\n            content: \"\";\r\n        }\r\n\r\n        multi-selection-item {\r\n            @apply pl-2.5 block relative;\r\n\r\n            &::before {\r\n                @apply absolute border-t border-dotted border-b-gray-400;\r\n                @apply left-3 top-5.5 w-3;\r\n                content: \"\";\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
